export default __webpack_public_path__ + "static/media/delivery.8e98e980.png";